import { render, staticRenderFns } from "./Create3.vue?vue&type=template&id=c8b8b386"
import script from "./Create3.vue?vue&type=script&lang=js"
export * from "./Create3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports